// @flow
import type { Action } from '../actions/gMapsError';

export type State = {
  errored: boolean
};

const initialState = {
  errored: false
};

export default function gMapsError(
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'SET_GMAPS_ERROR':
      return {
        errored: true
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
